<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="160"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_thirtyOneData'"
    :sqOptions="[ 11, 32]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesThirtyOne',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 71)
      } else if (value === 2) {
        this.$emit('handleProgress', 68)
      } else if (value === 3) {
        this.$emit('handleProgress', 67)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
